"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JSONSectionPropertiesConverter = void 0;
var common_1 = require("@devexpress/utils/lib/utils/common");
var section_column_properties_1 = require("../../../section/section-column-properties");
var section_properties_1 = require("../../../section/section-properties");
var json_section_enums_1 = require("../../enums/json-section-enums");
var json_columns_section_properties_converter_1 = require("./json-columns-section-properties-converter");
var JSONSectionPropertiesConverter = (function () {
    function JSONSectionPropertiesConverter() {
    }
    JSONSectionPropertiesConverter.convertFromJSON = function (obj) {
        var result = new section_properties_1.SectionProperties();
        result.marginLeft = obj[json_section_enums_1.JSONSectionProperty.MarginLeft];
        result.marginTop = obj[json_section_enums_1.JSONSectionProperty.MarginTop];
        result.marginRight = obj[json_section_enums_1.JSONSectionProperty.MarginRight];
        result.marginBottom = obj[json_section_enums_1.JSONSectionProperty.MarginBottom];
        result.columnCount = obj[json_section_enums_1.JSONSectionProperty.ColumnCount];
        result.space = obj[json_section_enums_1.JSONSectionProperty.Space];
        result.columnsInfo = json_columns_section_properties_converter_1.JSONColumnsSectionPropertiesConverter.convertFromJSON(obj[json_section_enums_1.JSONSectionProperty.ColumnsInfo]);
        result.pageWidth = obj[json_section_enums_1.JSONSectionProperty.PageWidth];
        result.pageHeight = obj[json_section_enums_1.JSONSectionProperty.PageHeight];
        result.startType = obj[json_section_enums_1.JSONSectionProperty.StartType];
        result.landscape = !!obj[json_section_enums_1.JSONSectionProperty.Landscape];
        result.equalWidthColumns = !!obj[json_section_enums_1.JSONSectionProperty.EqualWidthColumns];
        result.differentFirstPage = !!obj[json_section_enums_1.JSONSectionProperty.DifferentFirstPage];
        result.headerOffset = obj[json_section_enums_1.JSONSectionProperty.HeaderOffset];
        result.footerOffset = obj[json_section_enums_1.JSONSectionProperty.FooterOffset];
        result.paperKind = obj[json_section_enums_1.JSONSectionProperty.PaperKind];
        result.firstPageNumber = obj[json_section_enums_1.JSONSectionProperty.FirstPageNumber];
        result.continueNumbering = !!obj[json_section_enums_1.JSONSectionProperty.ContinueNumbering];
        if (!result.equalWidthColumns)
            while (result.columnCount > result.columnsInfo.length)
                result.columnsInfo.push(new section_column_properties_1.SectionColumnProperties(0, 0));
        return result;
    };
    JSONSectionPropertiesConverter.convertToJSON = function (source) {
        var result = {};
        result[json_section_enums_1.JSONSectionProperty.MarginLeft] = source.marginLeft;
        result[json_section_enums_1.JSONSectionProperty.MarginTop] = source.marginTop;
        result[json_section_enums_1.JSONSectionProperty.MarginRight] = source.marginRight;
        result[json_section_enums_1.JSONSectionProperty.MarginBottom] = source.marginBottom;
        result[json_section_enums_1.JSONSectionProperty.ColumnCount] = source.columnCount;
        result[json_section_enums_1.JSONSectionProperty.Space] = source.space;
        result[json_section_enums_1.JSONSectionProperty.ColumnsInfo] = json_columns_section_properties_converter_1.JSONColumnsSectionPropertiesConverter.convertToJSON(source.columnsInfo);
        result[json_section_enums_1.JSONSectionProperty.PageWidth] = source.pageWidth;
        result[json_section_enums_1.JSONSectionProperty.PageHeight] = source.pageHeight;
        result[json_section_enums_1.JSONSectionProperty.StartType] = source.startType;
        result[json_section_enums_1.JSONSectionProperty.Landscape] = common_1.boolToInt(source.landscape);
        result[json_section_enums_1.JSONSectionProperty.EqualWidthColumns] = common_1.boolToInt(source.equalWidthColumns);
        result[json_section_enums_1.JSONSectionProperty.DifferentFirstPage] = common_1.boolToInt(source.differentFirstPage);
        result[json_section_enums_1.JSONSectionProperty.HeaderOffset] = source.headerOffset;
        result[json_section_enums_1.JSONSectionProperty.FooterOffset] = source.footerOffset;
        result[json_section_enums_1.JSONSectionProperty.PaperKind] = source.paperKind;
        result[json_section_enums_1.JSONSectionProperty.FirstPageNumber] = source.firstPageNumber;
        result[json_section_enums_1.JSONSectionProperty.ContinueNumbering] = common_1.boolToInt(source.continueNumbering);
        return result;
    };
    return JSONSectionPropertiesConverter;
}());
exports.JSONSectionPropertiesConverter = JSONSectionPropertiesConverter;
